import { Button, Modal, Paper, Stack, Text, ThemeIcon, Title } from '@mantine/core';
import { IconCreditCard } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { primaryColor } from '../../constants/theme';
import { PageRoutes } from '../../constants/routes';
import { useApp } from '../../context/AppContext';

interface PaymentSetupModalProps {
  opened: boolean;
  onClose: () => void;
}

export const PaymentSetupModal = ({ opened, onClose }: PaymentSetupModalProps) => {
  const navigate = useNavigate();
  const { profile } = useApp();

  const handleGoToProfile = () => {
    onClose();
    navigate(`${PageRoutes.PROFILE}?professionalId=${profile?.id}`);
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      withCloseButton={false}
      size="sm"
      radius="md"
      closeOnClickOutside={false}
    >
      <Stack align="center" gap="md" pb="sm">
        <ThemeIcon size={64} radius="xl" color={primaryColor} variant="light">
          <IconCreditCard size={32} />
        </ThemeIcon>

        <Title order={3} fw="normal" ta="center">
          Payment Setup Required
        </Title>

        <Text ta="center" c="dimmed" size="sm">
          To add availability your payment account must be fully setup and enabled to receive payments.
        </Text>

        <Paper withBorder p="md" radius="sm" bg="var(--mantine-color-default-hover)" w="100%">
          <Text size="sm" ta="center">
            Head to your profile and complete the Stripe onboarding to start accepting bookings.
          </Text>
        </Paper>

        <Button color={primaryColor} fullWidth onClick={handleGoToProfile}>
          Go to Profile
        </Button>
      </Stack>
    </Modal>
  );
};
